(() => {
  const initializeCollectionDescriptions = (root = document) => {
    root.querySelectorAll('[data-tpc-collection-description]').forEach((description) => {
      if (description.dataset.tpcReady === 'true') return;

      const toggle = description.parentElement?.querySelector('[data-tpc-description-toggle]');
      if (!toggle) return;

      description.dataset.tpcReady = 'true';

      const update = () => {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          description.classList.remove('tpc-description--collapsible', 'is-expanded');
          toggle.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = 'Leer más';
          return;
        }

        description.classList.remove('tpc-description--collapsible', 'is-expanded');
        const shouldCollapse = description.scrollHeight > 145;
        description.classList.toggle('tpc-description--collapsible', shouldCollapse);
        toggle.hidden = !shouldCollapse;
      };

      toggle.addEventListener('click', () => {
        const expanded = description.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? 'Leer menos' : 'Leer más';
      });

      update();
      window.addEventListener('resize', update, { passive: true });
    });
  };

  const initializeProductStories = (root = document) => {
    root.querySelectorAll('[data-tpc-product-story]').forEach((story) => {
      if (story.dataset.tpcStoryReady === 'true') return;

      story.dataset.tpcStoryReady = 'true';
      story.classList.add('tpc-product-story');

      story.querySelectorAll('*').forEach((element) => {
        element.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === '') {
            node.textContent = '';
          }
        });
      });

      [...story.children].forEach((section, index) => {
        const text = section.textContent.replace(/\s+/g, ' ').trim().toLocaleUpperCase('es');

        if (text.includes('ENVÍO GRATIS') && text.includes('PAGO SEGURO')) {
          section.classList.add('tpc-story-trust');
        } else if (text.startsWith('RENDIMIENTO')) {
          section.classList.add('tpc-story-performance');
        } else if (text.startsWith('POR QUÉ LA ELEGIMOS')) {
          section.classList.add('tpc-story-why');
        } else if (text.startsWith('IDEAL PARA TU JUEGO') || text.startsWith('ENCAJA CONTIGO')) {
          section.classList.add('tpc-story-fit');
        } else if (text.startsWith('COMPARA CON')) {
          section.classList.add('tpc-story-compare');
        } else if (text.startsWith('ESPECIFICACIONES TÉCNICAS')) {
          section.classList.add('tpc-story-specs');
        } else if (text.startsWith('PREGUNTAS FRECUENTES')) {
          section.classList.add('tpc-story-faq');
        } else if (section.querySelector('a[href*="wa.me"]')) {
          section.classList.add('tpc-story-expert');
        } else if (index < 3 && section.querySelectorAll(':scope > span').length >= 2) {
          section.classList.add('tpc-story-tags');
        }
      });

      if (!story.querySelector('.tpc-story-trust')) {
        story.classList.add('tpc-product-story--legacy');
        const productTitle = document.querySelector('.product__title h1, .product__title')?.textContent.trim().toLocaleUpperCase('es') || '';

        [...story.children].forEach((section, index) => {
          const text = section.textContent.replace(/\s+/g, ' ').trim();
          const normalized = text.toLocaleUpperCase('es');

          if (index === 0 && /^H[1-4]$/.test(section.tagName) && productTitle.includes(normalized)) {
            section.classList.add('tpc-story-redundant-title');
          } else if (section.tagName === 'P' && normalized.startsWith('DESCRIPCIÓN')) {
            section.classList.add('tpc-story-legacy-intro');
          } else if (section.tagName === 'P' && ['CARACTERÍSTICAS', 'ESPECIFICACIONES TÉCNICAS', 'CONTENIDO DEL SET'].includes(normalized)) {
            section.classList.add('tpc-story-legacy-heading');
          }
        });
      }
    });
  };

  const initializeWhatsAppTracking = () => {
    if (document.documentElement.dataset.tpcWhatsAppTracking === 'true') return;

    document.documentElement.dataset.tpcWhatsAppTracking = 'true';
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href*="wa.me"]');
      if (!link) return;

      const placement = link.closest('.tpc-hero-actions')
        ? 'home_hero'
        : link.closest('.tpc-story-expert')
          ? 'product_advice'
          : link.closest('#chat-bubble')
            ? 'floating_widget'
            : 'whatsapp_link';

      const parameters = {
        method: 'whatsapp',
        placement,
        link_url: link.href,
        page_path: window.location.pathname,
      };

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', parameters);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'generate_lead', ...parameters });
      }
    }, true);
  };

  const initialize = (root = document) => {
    initializeCollectionDescriptions(root);
    initializeProductStories(root);
    initializeWhatsAppTracking();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
